import { useShallow } from "zustand/react/shallow";

import useCommandPaletteStore from "components/CommandPalette/store/useCommandPaletteStore";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import {
  selectGroupedByBucket,
  selectActiveActionId,
} from "components/CommandPalette/store/useCommandPaletteStore/selectors";
import { BUCKET_IDS } from "components/CommandPalette/constants";
import { CommandPaletteBucket } from "components/CommandPalette/types";

import CommandPaletteBucketItem from "../../elements/BucketItem";

type CommandPaletteMainListViewProps = {
  buckets: CommandPaletteBucket[];
};

const CommandPaletteMainListView = ({ buckets }: CommandPaletteMainListViewProps) => {
  const { groupedByBucket, activeActionId } = useCommandPaletteStore(
    useShallow((state) => ({
      groupedByBucket: selectGroupedByBucket(state),
      activeActionId: selectActiveActionId(state),
    }))
  );

  const bucketsWithActions = buckets.filter((bucket) => {
    const actions = groupedByBucket.get(bucket.id) || [];
    return actions.length > 0;
  });

  const hasNoResults = bucketsWithActions.every(
    (bucket) => bucket.id === BUCKET_IDS.SEARCH || bucket.id === BUCKET_IDS.ASK_INFRA_ASSISTANT
  );

  return (
    <Box direction="column" padding="x-large" gap="x-large" fullWidth>
      {hasNoResults && (
        <Box align="center" fullWidth>
          <Typography variant="p-body3" tag="span" color="secondary">
            No actions found
          </Typography>
        </Box>
      )}

      <Box direction="column" gap="x-large" fullWidth>
        {bucketsWithActions.map((bucket) => {
          const actions = groupedByBucket.get(bucket.id)!;

          return (
            <CommandPaletteBucketItem
              key={bucket.id}
              bucket={bucket}
              actions={actions}
              activeActionId={activeActionId}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default CommandPaletteMainListView;
